import React from "react";
import CrudPage from "@/components/common/CrudPage";
import { Gavel } from "lucide-react";
import { useApp } from "@/contexts/AppContext";
import { useAIOutputs } from "@/hooks/useAIOutputs";
import AICategoryPanel from "@/components/ai/AICategoryPanel";

function HearingsAIPanels() {
  const { currentCase } = useApp();
  const { outputs, addOutput } = useAIOutputs(currentCase?.id);
  return (
    <div className="space-y-4">
      <AICategoryPanel
        caseId={currentCase?.id} promptKey="hearing_prep" titleEl="Προετοιμασία Δικασίμου (AI)"
        outputs={outputs} onGenerated={addOutput}
      />
      <AICategoryPanel
        caseId={currentCase?.id} promptKey="trial_preparation" titleEl="Προετοιμασία Δίκης (AI)"
        outputs={outputs} onGenerated={addOutput}
      />
    </div>
  );
}

const STATUS = [
  { value: "todo", label: "Εκκρεμεί" },
  { value: "in_progress", label: "Σε εξέλιξη" },
  { value: "done", label: "Ολοκληρώθηκε" },
];

const FIELDS = [
  { k: "date", label: "Ημερομηνία", type: "date" },
  { k: "court", label: "Δικαστήριο" },
  { k: "purpose", label: "Σκοπός" },
  { k: "preparation_status", label: "Στάδιο προετοιμασίας", type: "select", options: STATUS },
  { k: "required_documents", label: "Απαιτούμενα έγγραφα", type: "textarea", rows: 2 },
  { k: "witnesses_attending", label: "Μάρτυρες που θα παρευρεθούν", type: "textarea", rows: 2 },
  { k: "arguments", label: "Επιχειρήματα προς προβολή", type: "textarea", rows: 3 },
  { k: "risks", label: "Κίνδυνοι", type: "textarea", rows: 2 },
  { k: "outcome", label: "Έκβαση", type: "textarea", rows: 2 },
  { k: "follow_up", label: "Επόμενες ενέργειες", type: "textarea", rows: 2 },
];

export default function Hearings() {
  return (
    <CrudPage
      slug="hearings" title="Δικάσιμοι"
      subtitle="Παρακολούθηση δικασίμων, προετοιμασίας και εκβάσεων."
      emptyIcon={Gavel} fields={FIELDS}
      defaultItem={{ preparation_status: "todo" }}
      listColumns={{
        title: it => it.purpose || "Δικάσιμος",
        subtitle: it => `${it.court || "—"} · ${it.date ? new Date(it.date).toLocaleDateString("el-GR") : "—"}`,
        body: it => it.arguments,
      }}
      badges={{ status: { field: "preparation_status" } }}
      extra={<HearingsAIPanels/>}
    />
  );
}
